<template>
    <div>
        <h3 class="text-lg leading-6 font-medium text-secondaryColor mb-4">
            {{ value.label }}
        </h3>
        <span>
            {{ value.value }}
        </span>
    </div>
</template>

<script>
export default {
    name: 'RadioAttribute',
    props: ['value']
}
</script>

<style scoped></style>
